import { Link, useLocation, useNavigate } from "react-router-dom";

interface OperatorMenuProps {
  variant?: "default" | "alt";
}

const OperatorMenu = ({ variant = "default" }: OperatorMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string) =>
    path === "/operador"
      ? pathname === "/operador"
      : pathname === path || pathname.startsWith(`${path}/`);

  const navItemClass = (path: string) =>
    variant === "alt"
      ? `py-2 sm:py-0 px-4 sm:px-0 hover:text-primary-600 ${isActive(path) ? "text-primary-600" : "text-gray-800"}`
      : `py-2 sm:py-0 px-4 sm:px-0 hover:text-gray-300 lg:hover:text-white lg:underline-offset-4 lg:decoration-2 lg:hover:underline ${isActive(path) ? "text-gray-300 lg:text-white lg:underline" : ""}`;

  const handleNavClick = (path: string) => (event: React.MouseEvent) => {
    if (isActive(path)) {
      event.preventDefault();
      navigate(path, { replace: true, state: { refreshKey: Date.now() } });
    }
  };

  return (
    <nav>
      <ul className={`flex flex-col font-bold text-lg sm:text-sm sm:flex-row sm:gap-6 sm:px-0`}>
        <li className={navItemClass("/operador")}>
          <Link to="/operador" onClick={handleNavClick("/operador")}>{"INÍCIO"}</Link>
        </li>
        <li className={navItemClass("/operador/clientes")}>
          <Link to="/operador/clientes" onClick={handleNavClick("/operador/clientes")}>{"CLIENTES"}</Link>
        </li>
        <li className={navItemClass("/operador/pedidos")}>
          <Link to="/operador/pedidos" onClick={handleNavClick("/operador/pedidos")}>{"PEDIDOS"}</Link>
        </li>
        <li className={navItemClass("/operador/whatsapp")}>
          <Link to="/operador/whatsapp" onClick={handleNavClick("/operador/whatsapp")}>{"WHATSAPP"}</Link>
        </li>
        <li className={navItemClass("/operador/balcao")}>
          <Link to="/operador/balcao" onClick={handleNavClick("/operador/balcao")}>{"BALCÃO"}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default OperatorMenu;
